import Container from "@vfuk/core-container";
import Paragraph from "@vfuk/core-paragraph/";
import Heading from "@vfuk/core-heading";
import { useTranslation } from "react-i18next";
import type { CustomerProduct } from "./Customer.types";
import { Stack, IconLink } from "@ucchub/ui";

type Props = {
  customerProduct: CustomerProduct;
  customerId: string;
};

const ProductDetails = ({ customerProduct, customerId }: Props) => {
  const { t } = useTranslation();

  return (
    <Container appearance="primary" elevation>
      <Heading level={4} weight={3}>
        {t("core:customers:product_details")}
      </Heading>
      <Stack justifyContent="space-between" align="baseline" width="100%">
        <Paragraph size={2} weight={3} noMargin>
          {customerProduct.name}
        </Paragraph>
        <IconLink
          size={3}
          icon={{ justify: "left", name: "chevron-right" }}
          text=""
          appearance="secondary"
          customRouterProps={{
            to: `/customers/${customerId}/product-config/${customerProduct.id}`,
          }}
        />
      </Stack>
    </Container>
  );
};

export default ProductDetails;
